import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DEFAULT_CURRENCY, formatAmount } from '../../../../../../utils/currency';
import { SD } from '../../../../../../utils/constants';

const DonationReview = ({
  schoolName = '',
  name = '',
  email = '',
  amount = '',
  donationType = '',
  extraFeatures,
}) => {
  return (
    /**
     * IMPORTANT: Don't delete data-hj-masked property.
     * It protects sensitive information to be visible in Hotjar video records.
     */
    <div className="donation-review-details" data-hj-masked="">
      <div className="donation-review-amount" data-component="donation-review-amount">
        {formatAmount(DEFAULT_CURRENCY, amount)} {donationType}
      </div>
      {extraFeatures.includes('school') && schoolName && (
        <div data-component="donation-review-school-name">School: {schoolName}</div>
      )}
      <div>
        <span data-component="donation-review-name">{name}</span>
        <span className="d-none d-md-inline">, </span>
        <span data-component="donation-review-email">{email}</span>
      </div>
    </div>
  );
};

DonationReview.propTypes = {
  schoolName: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  amount: PropTypes.string,
  donationType: PropTypes.string,
  extraFeatures: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = ({
  donationForm: {
    form: { values },
  },
}) => {
  const schoolName = values.school_name ? values.school_name : '';
  const firstName = values.first_name ? values.first_name : '';
  const lastName = values.last_name ? values.last_name : '';
  const amount = values.fundraisingCostsApplied ? values.totalAmount : values.amount;
  return {
    schoolName,
    name: String(`${firstName} ${lastName}`).trim(),
    email: values.email ? values.email : '',
    amount: amount ? amount : 0,
    donationType: values.type === SD ? 'donation' : 'monthly donation',
  };
};

export default connect(mapStateToProps)(DonationReview);
